export default "__VITE_ASSET__BQtbBS_4__"